import * as React from 'react';
import Slider from 'react-rangeslider';
import { DataTest } from '../../utilities/testAutomation';

interface OptionSliderProps extends DataTest {
  min: number;
  max: number;
  step: number;
  value: number;
  labels: {[key: number]: string};
  onChange: (value: number) => void;
}

export const OptionSlider = ({
  min,
  max,
  step,
  value,
  labels,
  onChange,
  dataTest,
}: OptionSliderProps) => (
  <div className="slider" {...dataTest}>
    <Slider
      min={min}
      max={max}
      step={step}
      value={value}
      labels={labels}
      tooltip={false}
      onChange={onChange}
    />
  </div>
);

export default OptionSlider;



// WEBPACK FOOTER //
// ./src/components/OptionSlider/OptionSlider.tsx